import { useTranslation } from '@mc/i18n'
import { Image, TileOverlay } from '@mc/design-system'
import { STATIC_IMAGE_BASE } from '@mc/constants'

import { DROPPABLE_QUIZ_MODULE_I18N_NAMESPACE } from 'experiments/pen-4558_v1-droppable-quiz-module/i18n'

import classes from './Cover.module.scss'

export const CoverDesktop = () => {
  const { t } = useTranslation(DROPPABLE_QUIZ_MODULE_I18N_NAMESPACE)

  return (
    <div className='col-6 position-relative'>
      <div
        className={`position-absolute mc-w-100 mc-px-11 ${classes.imageOverlayContainer}`}
      >
        <Image
          src={`${STATIC_IMAGE_BASE}/droppable-quiz-mc-logo.png`}
          width={203}
          height={67}
          className='mc-bg-transparent mc-m-auto'
        />
        <h2 className='mc-text-h2 mc-text--center mc-mt-3'>
          {t('droppableQuiz.title')}
        </h2>
      </div>
      <Image src={`${STATIC_IMAGE_BASE}/droppable-quiz-img.png`} />
    </div>
  )
}

export const CoverMobile = () => {
  const { t } = useTranslation(DROPPABLE_QUIZ_MODULE_I18N_NAMESPACE)

  return (
    <>
      <div className='position-relative uncontainer'>
        <div className='d-block d-sm-none'>
          <Image
            src={`${STATIC_IMAGE_BASE}/droppable-quiz-img-mobile.png`}
            height={200}
          />
        </div>
        <div className='d-none d-sm-block'>
          <Image
            src={`${STATIC_IMAGE_BASE}/droppable-quiz-img-mobile.png`}
            height={400}
          />
        </div>

        <TileOverlay type='gradient-bottom' color='0, 0, 0' />
        <div
          className={`position-absolute container ${classes.imageOverlayContainerMobile}`}
        >
          <Image
            src={`${STATIC_IMAGE_BASE}/droppable-quiz-mc-logo.png`}
            width={134}
            height={44}
            className='mc-bg-transparent'
          />
        </div>
      </div>
      <h2 className='mc-text-h2 mc-mt-3 mc-mb-8'>{t('droppableQuiz.title')}</h2>
    </>
  )
}
